import React, { useEffect, useState } from 'react';
import Header from '../sharedComponents/Header';
import Footer from '../sharedComponents/footer';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import HeroSectionUI from '../sharedComponents/HeroSectionUI';
import AOS from "aos";
import "aos/dist/aos.css";
import { motion } from "framer-motion";
import projectsData from './Project';

export const cardsData = [
  {
    id: 1,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/cigna-healthcare-platform.webp",
    bgColor: 'bg-[#003FF5]',
    altText: 'cigna-healthcare-platform',
    title: 'Cigna',
    description: 'Cigna is a Fortune 15 global healthcare and insurance company founded in 1982.',
    page: 'cigna',
    isMobile: false,
  },
  {
    id: 2,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/sonic-healthcare-ai-driven-platform-for-diagnostic-servicesn.webp",
    bgColor: 'bg-blue-900',
    altText: 'sonic-healthcare-ai-driven-platform-for-diagnostic-services',
    title: 'Sonic Healthcare',
    description: 'Sonic Healthcare is a prominent global healthcare company specializing in high-quality diagnostic services.',
    page: 'sonichealthcare',
    isMobile: true,
  },
  {
    id: 3,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/canopie-mobile-app-for-maternal-mental-health.webp",
    bgColor: 'bg-blue-100',
    altText: 'canopie-mobile-app-for-maternal-mental-health',
    description: 'Canopie is a pioneering mobile application designed to enhance maternal health.',
    title: 'Canopie',
    page: 'canopie',
    isMobile: false,
  },
  {
    id: 4,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/image+(2).png",
    bgColor: 'bg-blue-500',
    altText: 'medhost-temperature-controlled-logistics-and-supply-chain-solution',
    page: 'medhost',
    description: `MEDHOST's Emergency Department Information System (EDIS) supports emergency departments by enhancing patient care.`,
    title: 'Medhost',
    isMobile: false,
  },
  {
    id: 5,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/cryoport-temperature-controlled-logistics-and-supply-chain-solution.webp",
    bgColor: 'bg-blue-500',
    altText: 'cryoport-temperature-controlled-logistics-and-supply-chain-solution',
    page: 'cryoport',
    description: 'Cryoport Systems is a market leader in globally integrated temperature-controlled supply chain support.',
    title: 'Cryoport',
    isMobile: false,
  },
  {
    id: 6,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/cloudshim-cloud-management-and-cost-optimization-tool.webp",
    bgColor: 'bg-orange-500',
    altText: 'cloudshim-cloud-management-and-cost-optimization-tool',
    page: 'cloudshim',
    description: 'Cloudshim is a platform that allows to easily user to visualize, track, and map their AWS cloud resources.',
    title: 'Cloudshim',
    isMobile: false,
  },
  {
    id: 7,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/paypal-payment-platform-for-merchants.webp",
    bgColor: 'bg-orange-500',
    altText: 'paypal-payment-platform-for-merchants',
    description: 'PayPal recognized the need to improve its existing features to meet the evolving demands of merchants.',
    title: 'PayPal',
    page: 'paypal',
    isMobile: false,
  },
  {
    id: 8,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/acima-lease-to-own-solutions-by-webkorps.jpg",
    bgColor: 'bg-[#020441]',
    altText: 'acima-lease-to-own-solutions-by-webkorps',
    title: 'ACIMA',
    description: 'Acima is a prominent lease-to-own service that allows customers to acquire items without traditional credit.',
    page: 'acima',
    isMobile: false,
  },
  {
    id: 9,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/tonik.webp",
    bgColor: 'bg-blue-800',
    altText: 'tonik-bank-mobile-app-for-enhanced-ui/ux-and-scalability',
    title: 'Tonik',
    description: 'Tonik Bank is a pioneering digital-only bank in the Philippines.',
    page: 'tonik',
    isMobile: true,
  },
  {
    id: 10,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/puravankara.webp",
    bgColor: 'bg-blue-800',
    altText: 'puravankara-email-solution-for-enhanced-communication-and-engagement',
    title: 'Purvankara',
    description: `Puravankara Limited is one of India's most admired and trusted real estate players.`,
    page: 'purvankara',
    isMobile: false,
  },
  {
    id: 11,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/property-finder-buyer-centric-real-estate-platform.webp",
    bgColor: 'bg-blue-800',
    altText: 'property-finder-buyer-centric-real-estate-platform',
    title: 'Property Finder',
    description: 'Property Finder is a specialized platform designed to connect buyers with the right properties.',
    page: 'propertyfinder',
    isMobile: false,
  },
  {
    id: 12,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/shree-laxmi-sheels-crm-system-with-customizable-dashboards.webp",
    bgColor: 'bg-b-800',
    altText: 'shree-laxmi-sheels-crm-system-with-customizable-dashboards',
    title: 'Shree Laxmi Steels',
    description: 'Shree Laxmi Steels is a prominent Indian steel manufacturing brand.',
    page: 'shreelaxmisteels',
    isMobile: false,
  },
  {
    id: 13,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/verizon-rpa-powered-hr-management-automation-tool.webp",
    bgColor: 'bg-[#EC3D26]',
    altText: 'verizon-rpa-powered-hr-management-automation-tool',
    title: 'Verizon',
    description: 'Verizon has initiated a project to enhance its Human Resource Management Automation by integrating RPA.',
    page: 'verizon',
    isMobile: false,
  },
  // Remaining items (extras at end, same order as original)
  {
    id: 14,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/abb-digital-transformation-enhancing-efficiency-with-iot-integration.webp",
    bgColor: 'bg-red-500',
    altText: 'abb-digital-transformation-enhancing-efficiency-with-iot-integration',
    page: 'abb',
    description: `ABB is a global engineering company that provides solutions to make the future more sustainable and resource-efficient.`,
    title: 'ABB',
    isMobile: false,
  },
    {
    id: 15,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/my-kia-app-mobile-app-for-integrated-sales-and-service.webp",
    bgColor: 'bg-gray-500',
    altText: 'my-kia-app-mobile-app-for-integrated-sales-and-service',
    description: `Standalone mobile app for Kia owners, integrating sales, service management, and loyalty programs.`,
    title: 'My Kia APP',
    page: 'mykiaapp',
    isMobile: true,
  },
   {
    id: 16,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/the-fragrances-shop-mobile-app-to-enhancing-customer-engagement-and-loyalty.webp",
    bgColor: 'bg-blue-900',
    altText: 'the-fragrances-shop-mobile-app-to-enhancing-customer-engagement-and-loyalty',
    title: 'The Fragrance Shop',
    description: `The Fragrance Shop is the UK's largest independent retailer of fragrances and beauty products.`,
    page: 'thefragranceshop',
    isMobile: true,
  },
    {
    id: 17,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/pebble-custom-mobile-app-for-pebble-smartwatches.webp",
    bgColor: 'bg-red-500',
    altText: 'pebble-custom-mobile-app-for-pebble-smartwatches',
    title: 'Pebble',
    description: 'Pebble is a renowned smartwatch brand known for its innovative features and user-friendly interface.',
    page: 'pebble',
    isMobile: true,
  },
    {
    id: 18,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/styla-streamlining-e-commerce-with-pwas-and-no-code-solutions.jpg",
    bgColor: 'bg-[#4A33CC]',
    altText: 'styla-streamlining-e-commerce-with-pwas-and-no-code-solutions',
    title: 'Styla',
    description: 'Styla is a cutting-edge storefront technology company providing integrated technologies for e-commerce platforms.',
    page: 'styla',
    isMobile: false,
  },
  {
    id: 19,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/abp-news-mobile-application-for-prominent-media-organization.webp",
    bgColor: 'bg-[#A11F15]',
    altText: 'abp-news-mobile-application-for-prominent-media-organization',
    title: 'ABP News',
    description: 'ABP News is a prominent media organization in India, delivering timely news and updates.',
    page: 'abpnews',
    isMobile: false,
  },
  {
    id: 20,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/inkind-customer-loyalty-and-rewards-management-software-for-restaurant.jpg",
    bgColor: 'bg-[#E0B95E]',
    altText: 'inkind-customer-loyalty-and-rewards-management-software-for-restaurant',
    title: 'inKind',
    description: 'inKind is an innovative platform designed to reward loyal customers while supporting local restaurants.',
    page: 'inkind',
    isMobile: false,
  },

  {
    id: 21,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/cardinalhire-online-recruiting-software-and-hiring-platform.webp",
    bgColor: 'bg-blue-800',
    altText: 'cardinalhire-online-recruiting-software-and-hiring-platform',
    title: 'Cardinal Hire',
    description: 'CardinalHire is a dynamic platform designed to bridge the gap between top tech talent and leading tech companies.',
    page: 'cardinalhire',
    isMobile: false,
  },
  {
    id: 22,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/scoutr-talent-management-system-with-advanced-matching-algorithms.webp",
    bgColor: 'bg-[#2E4488]',
    altText: 'scoutr-talent-management-system-with-advanced-matching-algorithms',
    title: 'Scoutr',
    description: 'Scoutr is an innovative platform designed to transform talent management.',
    page: 'scoutr',
    isMobile: false,
  },
  {
    id: 23,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/wazir-performance-security-and-feature-upgrades-for-a-leading-crypto-app.webp",
    bgColor: 'bg-white-800',
    altText: 'wazir-performance-security-and-feature-upgrades-for-a-leading-crypto-app',
    title: 'Wazir',
    description: 'Wazir is a leading cryptocurrency trading application.',
    page: 'wazir',
    isMobile: true,
  },
  {
    id: 24,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/ethmeme-simplifying-crypto-token-creation.webp",
    bgColor: 'bg-blue-800',
    altText: 'ethmeme-simplifying-crypto-token-creation',
    title: 'EtheMEME',
    description: 'Ethmeme.fun is an innovative platform designed to simplify cryptocurrency token creation.',
    page: 'ethememe',
    isMobile: false,
  },

  {
    id: 25,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/wendy-digital-ordering-solutions-for-food-industry.webp",
    bgColor: 'bg-blue-800',
    altText: 'wendy-digital-ordering-solutions-for-food-industry',
    title: `Wendy's`,
    description: `Wendy's has recently introduced innovative features aimed at enhancing customer experience.`,
    page: 'wendy',
    isMobile: false,
  },
  {
    id: 26,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/digikagaz-document-automation-for-legal-professionals.webp",
    bgColor: 'bg-blue-800',
    altText: 'digikagaz-document-automation-for-legal-professionals',
    title: 'Digikagaz',
    description: 'DigiKagaz was conceived with the vision of revolutionizing the way legal professionals handle document automation.',
    page: 'digikagaz',
    isMobile: false,
  },
  {
    id: 27,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/bhaibhandhu.webp",
    bgColor: 'bg-purple-500',
    altText: 'bhai-bandhu-mobile-and-web-app-b2b-marketplace',
    title: 'Bhai Bandhu',
    description: 'Bhai Bandhu is an innovative B2B marketplace specifically designed for Indian ethnic wear.',
    page: 'bhaibandhu',
    isMobile: true,
  },
 



    {
    id: 28,
    imageSrc: "https://webkorps-app.s3.us-east-1.amazonaws.com/cryoport-temperature-controlled-logistics-and-supply-chain-solution.webp",
    bgColor: 'bg-red-500',
    altText: 'cryoport-temperature-controlled-logistics-and-supply-chain-solution',
    title: 'E-Learning App',
    description: 'Webkorps successfully developed a confidential e-learning application.',
    page: 'elearningapp',
    isMobile: false,
  },
];

// ── Helpers ──────────────────────────────────────────────────────────────────

// Returns the industry value(s) for a card — always as an array for uniform handling
const getIndustries = (page) => {
  const project = projectsData.find(p => p.id === page);
  if (!project?.industry) return [];
  return Array.isArray(project.industry) ? project.industry : [project.industry];
};

// Collect every unique industry label across all projects that have a card
const ALL_INDUSTRIES = [...new Set(
  cardsData.flatMap(card => getIndustries(card.page))
)].sort();

// ── Component ─────────────────────────────────────────────────────────────────

const CaseStudy = () => {
  const [selectedIndustries, setSelectedIndustries] = useState([]);
  const [hoveredCard, setHoveredCard] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 500, easing: "ease", once: true });
  }, []);

  const toggleIndustry = (industry) => {
    setSelectedIndustries(prev =>
      prev.includes(industry)
        ? prev.filter(i => i !== industry)
        : [...prev, industry]
    );
  };

  // A card matches if it belongs to ANY of the selected industries
  const filteredData = cardsData.filter(card => {
    if (selectedIndustries.length === 0) return true;
    const cardIndustries = getIndustries(card.page);
    return selectedIndustries.some(sel => cardIndustries.includes(sel));
  });

  return (
    <>
      <Helmet>
        <title>Our Work and Case Study | Webkorps</title>
        <meta name="description" content="Explore our latest work and case studies across various technologies and industries." />
        <meta property="og:url" content="https://www.webkorps.com/case-study" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Our Work and Case Study | Webkorps" />
        <meta property="og:description" content="Explore our latest work and case studies across various technologies and industries." />
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="webkorps.com" />
        <meta property="twitter:url" content="https://www.webkorps.com/case-study" />
        <meta name="twitter:title" content="Our Work and Case Study | Webkorps" />
        <meta name="twitter:description" content="Explore our latest work and case studies across various technologies and industries." />
        <link rel="canonical" href="https://www.webkorps.com/case-study" />
      </Helmet>

      <Header />

      <div className="bg-gray-100 w-full text-center md:text-left pt-[80px]">
        <HeroSectionUI
          title={'Real Success, Proven Results: Explore Our Case Studies'}
          subtitle={'See how our expertise transforms business challenges into success'}
          description={'At Webkorps, we deliver tailored IT solutions and services that drive innovation, efficiency, and growth.'}
          image={'https://webkorps-app.s3.us-east-1.amazonaws.com/real-success-proven-results-explore-our-case-studies.jpg'}
          imageAlt={'case study'}
          leftSection={false}
        />
      </div>

      {/* ── Industry Filter ── */}
      <div className="w-full bg-white px-[5%] xl:px-[50px] ipad-pro:px-[50px] pt-8 pb-6 border-b border-gray-100">
        <div className="flex flex-wrap justify-center gap-2 xl:gap-3">
          {ALL_INDUSTRIES.map((industry) => {
            const isActive = selectedIndustries.includes(industry);
            return (
              <button
                key={industry}
                onClick={() => toggleIndustry(industry)}
                className={`
                  inline-flex items-center gap-2 px-4 py-[7px] rounded-full
                  text-[0.8125rem] xl:text-[0.875rem] font-inter font-semibold
                  border transition-all duration-150 select-none
                  ${isActive
                    ? "bg-[#1887C9] border-[#1887C9] text-white shadow-md"
                    : "bg-white border-gray-200 text-gray-600 hover:border-[#1887C9] hover:text-[#1887C9]"
                  }
                `}
              >
                {industry}
              </button>
            );
          })}
        </div>
      </div>

      {/* ── Cards Grid ── */}
      <div className="w-full mt-3 px-[5%] md:px-[5%] xl:px-[50px] ipad-pro:px-[50px] relative z-0 overflow-hidden">
        {filteredData.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-24 px-[5%] text-center">
            <div className="w-16 h-16 rounded-full bg-[#EBF5FC] flex items-center justify-center mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-[#1887C9]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <p className="text-[1.125rem] font-bold text-gray-700 font-inter mb-1">No case studies found</p>
            <p className="text-[0.9375rem] text-gray-400 font-inter mb-6">
              No results for the selected {selectedIndustries.length === 1 ? "industry" : "industries"}
            </p>
            <button
              onClick={() => setSelectedIndustries([])}
              className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-[#1887C9] text-white text-[0.875rem] font-bold font-inter hover:bg-[#0F5A8F] transition-colors duration-150"
            >
              Clear filters
            </button>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 ipad-pro:grid-cols-2 gap-8 xl:gap-8 ipad-pro:gap-8 mt-6 mb-8 ipad-sum:justify-items-center">
            {filteredData.map((card, index) => (
              <div
                key={index}
                className="relative w-[352px] xl:w-[352px] ipad-pro:w-[352px] md:w-[330px] h-[328px] rounded-lg shadow-2xl overflow-hidden group z-10 cursor-pointer"
                onClick={() => navigate(`/case-study/${card.page}`)}
              >
                <div className="absolute inset-0 bg-white "></div>
                <div className={`absolute inset-0 ${card.bgColor}`}  style={{
    clipPath: "polygon(100% 0, 100% 100%, 0 100%)"
  }}></div>

                <motion.div
                  className="relative z-10 flex items-center justify-center h-full"
                  key={card.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                  onMouseEnter={() => setHoveredCard(card.id)}
                  onMouseLeave={() => setHoveredCard(null)}
                >
                  <Link to={`/case-study/${card.page}`}>
                    <img
                      width="800"
                      height="600"
                      sizes="(max-width: 640px) 100vw, (max-width: 1280px) 50vw, 33vw"
                      loading="lazy"
                      src={card.imageSrc}
                      alt={card.altText}
                      className="max-w-full"
                    />
                    <div className="absolute w-full bottom-0 left-0 text-white bg-black bg-opacity-[0.8] p-4 shadow-[0px_0px_30px_10px_rgba(0,0,0,0.7)]">
                      <p className="text-[1rem] xl:text-[1.5rem] ipad-pro:text-[1.35rem] md:text-[1.5rem] leading-[1.9rem] font-semibold">
                        {card.title}
                      </p>
                      {hoveredCard === card.id && (
                        <motion.p
                          initial={{ opacity: 0, y: 10 }}
                          animate={{ opacity: 1, y: 0 }}
                          className="text-sm break-words whitespace-normal text-[13px] xl:text-[16px] ipad-pro:text-[16px] md:text-[14px] leading-[22.6px] pt-[15px]"
                        >
                          {card.description}
                        </motion.p>
                      )}
                    </div>
                  </Link>
                </motion.div>
              </div>
            ))}
          </div>
        )}
      </div>

      <Footer />
    </>
  );
};

export default CaseStudy;